import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
export function DatePicker(props) {
    return React.createElement(AntDatePicker, Object.assign({}, props));
}
